import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "info" | "destructive" | "success";
}

export function Alert({ className, variant = "info", ...props }: AlertProps) {
  const variants = {
    info: "border-blue-600/30 bg-blue-600/10 text-blue-200",
    destructive: "border-destructive/40 bg-destructive/10 text-destructive-foreground",
    success: "border-emerald-600/30 bg-emerald-600/10 text-emerald-200",
  };
  return (
    <div
      role="alert"
      className={cn("rounded-lg border p-4 text-sm", variants[variant], className)}
      {...props}
    />
  );
}